import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Flickity from 'flickity';

// function to re invoke announcement-bar flickty slider on page width change 
function resizeDetect () {
var sliderDesk = document.querySelector('.announcement-bar-widget__content-desk')
var sliderPhone =document.querySelector('.announcement-bar-widget__content--phone')
var sliderDeskWrapper = document.querySelector('.announcement-bar--trustpilot--desk')
var sliderPhoneWrapper =document.querySelector('.announcement-bar--trustpilot-phone')

if (!!sliderDesk && screen.width > 640 ) {
  if (sliderDeskWrapper != null) {
    sliderDeskWrapper.style.display="block";
    setTimeout(function () {
      sliderDeskWrapper.style.opacity="1";
    }, 1000);
  }
  if (sliderPhoneWrapper != null) {
    sliderPhoneWrapper.style.display="none";
    sliderPhoneWrapper.style.opacity="0";
  }

  var flkty = new Flickity(sliderDesk, {
    pageDots: false,
    prevNextButtons: false,
    wrapAround: false,
    resize: false,
    draggable: true,
    fade: 'fade',
    cellAlign: 'center',
    adaptiveHeight: true,
    autoPlay: 4500,
    selectedAttraction: 0.2,
    friction: 0.8
  });


}
if (!!sliderPhone && screen.width < 641) {
  if (sliderDeskWrapper != null) {
    sliderDeskWrapper.style.display="none";
    sliderDeskWrapper.style.opacity="0";
  }

  if (sliderPhoneWrapper != null) {
    sliderPhoneWrapper.style.display="block";
    setTimeout(function () {
      sliderPhoneWrapper.style.opacity="1";
    }, 1000);
  }

  var flkty = new Flickity(sliderPhone, {
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    resize: false,
    draggable: true,
    fade: 'fade',
    cellAlign: 'center',
    adaptiveHeight: true,
    autoPlay: 4500,
    selectedAttraction: 0.2,
    friction: 0.8
  });
}
}
window.addEventListener('resize', resizeDetect);
window.addEventListener("load",resizeDetect);
